"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadDashboardAlerts = void 0;
function loadDashboardAlerts(ctx) {
    var backend = ctx.backend, workspace = ctx.workspace, dashboardRef = ctx.dashboardRef;
    // no need to load anything if the backend does not support setting the alerts in the first place
    if (!backend.capabilities.supportsKpiWidget) {
        return Promise.resolve([]);
    }
    return backend.workspace(workspace).dashboards().getDashboardWidgetAlertsForCurrentUser(dashboardRef);
}
exports.loadDashboardAlerts = loadDashboardAlerts;
//# sourceMappingURL=loadDashboardAlerts.js.map